module.exports = __webpack_public_path__ + "static/img/1_2_3.561d2e68.jpg";